import { rgba } from "polished";
import React from "react";
import styled from "styled-components";

import PerlinNoiseDarkBkg from "../../static/illustration/perlin-noise-dark.png";
import PerlinNoiseLightBkg from "../../static/illustration/perlin-noise-light.png";
import { Theme } from "../../theme/common/theme";

const getPerlinNoiseBg = ({ theme }: { theme: Theme }) =>
  theme.type === "LIGHT" ? PerlinNoiseLightBkg : PerlinNoiseDarkBkg;

const PerlinNoise = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${getPerlinNoiseBg});
  background-size: 256px 256px;
  animation: translate-bg 36s linear infinite;
  background-color: ${({ theme }) => rgba(theme.highlightColor, 0.1)};
  opacity: ${({ theme }) => (theme.type === "LIGHT" ? 0.45 : 0.65)};
  transition: all 0.3s ease-out;

  @keyframes translate-bg {
    from {
      background-position: 0px 0px;
    }
    to {
      background-position: -256px 0px;
    }
  }
`;

const DotGridMask = styled.div`
  position: absolute;
  inset: 0;
  mask-size: 15px 15px;
  mask-image: radial-gradient(white, white 1px, transparent 1px, transparent);
`;

const RadialMask = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  mask-image: radial-gradient(
    circle at 70% 50%,
    rgba(255 255 255 / 1) 30%,
    transparent 72%
  );
`;

export function PerlinDotGrid({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <RadialMask className={className}>
      <DotGridMask>
        <PerlinNoise />
      </DotGridMask>
    </RadialMask>
  );
}
